import React from "react";

/**
 * Simple, tasteful editorial marquee.
 * Duplicates children so the loop feels seamless.
 */
export default function EditorialMarquee({ items = [], accent = false }) {
  const merged = [...items, ...items];
  return (
    <div className={`marquee-row py-8 md:py-10 ${accent ? "bg-ink-800" : "bg-ink-950"}`}>
      <div className="marquee-inner">
        {merged.map((t, i) => (
          <span
            key={i}
            className="font-display uppercase text-6xl md:text-8xl tracking-tighter leading-none text-transparent"
            style={{ WebkitTextStroke: "1px rgba(244,244,242,0.35)" }}
          >
            {t}
            <span className="mx-8 text-proform-red" style={{ WebkitTextStroke: 0 }}>●</span>
          </span>
        ))}
      </div>
    </div>
  );
}
